export default __webpack_public_path__ + "static/media/icon-select-white.d47e9623.svg";